// const API_BASE_URL = "http://localhost/serverstock_uk/serverstock_api";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API = {
  base: API_BASE_URL,

  // Login method - sends JSON data
  login: async (email, password) => {
    const url = `${API.base}/login.php`;

    const encode = (value) => {
      try {
        if (typeof window !== "undefined" && window.btoa) {
          return window.btoa(unescape(encodeURIComponent(value)));
        }
        return btoa(value);
      } catch {
        return value;
      }
    };

    try {
      const payload = new URLSearchParams();
      payload.append("email", encode(email.trim()));
      payload.append("password", encode(password));

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: payload,
      });

      if (!res.ok && res.status !== 401 && res.status !== 400) {
        const errorText = await res.text();
        throw new Error(`HTTP error! status: ${res.status} - ${errorText}`);
      }

      const data = await res.json();
      return { data, status: res.status };
    } catch (err) {
      if (err.message.includes("fetch")) {
        throw new Error(
          `Cannot connect to ${url}. Make sure:\n1. XAMPP Apache is running\n2. Open ${API.base}/test_connection.php in browser\n3. Check folder path`
        );
      }
      throw err;
    }
  },

  // General POST method for authenticated requests
  post: async (url, data) => {
    const token = localStorage.getItem("authToken") || "";
    const res = await fetch(API.base + url, {
      method: "POST",
      headers: {
        Authorization: token,
        ...(data instanceof FormData
          ? {}
          : { "Content-Type": "application/x-www-form-urlencoded" }),
      },
      body: data instanceof FormData ? data : new URLSearchParams(data),
    });
    return { data: await res.json(), status: res.status };
  },
};

export default API;
